<template>
  <!-- 销售管理 -->
  <div>
    <el-tabs type="border-card">
      <el-tab-pane label="销售出库">
        <SalesDelivery></SalesDelivery>
      </el-tab-pane>
      <el-tab-pane label="销售单据查询">
        <SalesDocQuery></SalesDocQuery>
      </el-tab-pane>
      <el-tab-pane label="客户退货">
        <CustomerReturns></CustomerReturns>
       </el-tab-pane>
      <el-tab-pane label="客户退货查询">
        <CustomerQuery></CustomerQuery>
      </el-tab-pane>
      <el-tab-pane label="当前库存查询">
        <InventoryQuery></InventoryQuery>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import CustomerQuery from "./CustomerQuery"; //客户退货查询
import CustomerReturns from "./CustomerReturns"; //客户退货
import InventoryQuery from "./InventoryQuery"; //当前库存查询
import SalesDelivery from "./SalesDelivery"; //销售出库
import SalesDocQuery from "./SalesDocQuery"; //销售单据查询
export default {
  components: {
    CustomerQuery,
    CustomerReturns,
    InventoryQuery,
    SalesDelivery,
    SalesDocQuery,
  },
  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped></style>
